module.exports = __webpack_public_path__ + "static/media/laptop.432b92fe.svg";